import { Component } from '@angular/core';

@Component({
  selector: 'app-grid-shape',
  imports: [],
  templateUrl: './grid-shape.html'
})
export class GridShape {

}
